// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17IBB","image":"Header_image__B9lQj","name":"Header_name__2CM46","info":"Header_info__1StKD","infoRow":"Header_infoRow__2qSgY"};